import React, { FC, SVGProps } from "react";

import { MaterialType } from "../../types/materials";
import { getMaterialLogo } from "../../utils/materials";

export interface BiesseMaterialLogoProps extends SVGProps<SVGSVGElement> {
  material?: MaterialType;
}

export const BiesseMaterialLogo: FC<BiesseMaterialLogoProps> = ({ material, ...rest }) => {
  const typedMaterial = material as MaterialType;
  const MaterialLogoComponent = typedMaterial ? getMaterialLogo(typedMaterial) : null;
  return MaterialLogoComponent && <MaterialLogoComponent {...rest} />;
};
